/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureConsentUrlResponse {
  /**
  * The URL to consent to Azure permissions
  */
  'url': string;
  /**
  * The error message
  */
  'error'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "url",
      "baseName": "url",
      "type": "string",
      "format": ""
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureConsentUrlResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

